<template>
    <div class="eos-report__revenue-labour-history">
       <div class="eos-report__revenue-labour-history--date">
            <el-select v-model="typeSelected" placeholder="Select">
                <el-option 
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    @change="handleTypeChange">
                </el-option>
            </el-select>
            <el-date-picker
                v-model="date"
                type="date"
                placeholder="Pick a day"
                :picker-options="pickerOptions">
            </el-date-picker>
            <el-button type="primary">Generate</el-button>
       </div>

       <el-collapse v-model="activeNames">
            <el-collapse-item v-for="(item, i) in tableData" :key="`eos-${i}`" :title="item.date" :name="item.date">
               <div class="custom-table table-wrp">
                <el-table
                    :data="item.children"
                    style="width: 100%"
                    :header-cell-style="{background:'#f5f7fa', color:'#606266', fontWeight:'bold'}"
                    :row-class-name="tableRowClassName"
                    border>
                        <el-table-column
                            prop="shift"
                            label=""
                            width="100">
                        </el-table-column>
                        <el-table-column
                            label="Revenue"
                            align="center">
                            <el-table-column
                                prop="revenueTarget"
                                label="Target"
                                width="120"
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="revenueActual"
                                label="Actual"
                                width="120"
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="revenueVariance"
                                label="Variance"
                                width="120"
                                align="center">
                            </el-table-column>
                        </el-table-column>
                        <el-table-column
                            label="Labour"
                            align="center">
                            <el-table-column
                                prop="labourTarget"
                                label="Target"
                                width="120"
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="labourActual"
                                label="Actual"
                                width="120"
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="labourActualPercent"
                                label="Actual %"
                                width="100"
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="labourVariance"
                                label="Variance"
                                width="120"
                                align="center">
                            </el-table-column>
                        </el-table-column>
                    </el-table>
                </div>
            </el-collapse-item>
      
        </el-collapse>
    </div>
</template>

<script>
export default {
    data() {
        return {
            date: new Date(),
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
            options: [
                {
                    value: 'daily',
                    label: 'Daily'
                }, 
                {
                    value: 'weekly',
                    label: 'Weekly'
                }, 
                {
                    value: 'monthly',
                    label: 'Monthly'
                }
            ],
            typeSelected: 'daily',
            activeNames: ["9 June 2025", "10 June 2025"],
            tableData: [
                {
                    date: '9 June 2025',
                    children: [
                        {
                            shift: 'Day Shift',
                            revenueTarget: '$2,000.00',
                            revenueActual: '$2,200.00',
                            revenueVariance: '$200.00',
                            labourTarget: '$700.00',
                            labourActual: '$600.00',
                            labourActualPercent: '27.27%',
                            labourVariance: '-$100.00'
                        },
                        {
                            shift: 'Night Shift',
                            revenueTarget: '$2,000.00',
                            revenueActual: '$2,200.00',
                            revenueVariance: '$200.00',
                            labourTarget: '$700.00',
                            labourActual: '$600.00',
                            labourActualPercent: '27.27%',
                            labourVariance: '-$100.00'
                        },
                        {
                            shift: 'Dinner',
                            revenueTarget: '$800.00',
                            revenueActual: '$950.00',
                            revenueVariance: '$150.00',
                            labourTarget: '$300.00',
                            labourActual: '$220.00',
                            labourActualPercent: '23.16%',
                            labourVariance: '-$80.00'
                        },
                        {
                            shift: 'Supper',
                            revenueTarget: '$1,200.00',
                            revenueActual: '$1,250.00',
                            revenueVariance: '$50.00',
                            labourTarget: '$400.00',
                            labourActual: '$380.00',
                            labourActualPercent: '30.40%',
                            labourVariance: '-$20.00'
                        },
                        {
                            shift: 'Day Total',
                            revenueTarget: '$4,000.00',
                            revenueActual: '$4,400.00',
                            revenueVariance: '$400.00',
                            labourTarget: '$1,400.00',
                            labourActual: '$1,200.00',
                            labourActualPercent: '27.27%',
                            labourVariance: '-$200.00'
                        }
                    ]
                },
                {
                    date: '10 June 2025',
                    children: [
                        {
                            shift: 'Day Shift',
                            revenueTarget: '$2,000.00',
                            revenueActual: '$2,200.00',
                            revenueVariance: '$200.00',
                            labourTarget: '$700.00',
                            labourActual: '$600.00',
                            labourActualPercent: '27.27%',
                            labourVariance: '-$100.00'
                        },
                        {
                            shift: 'Night Shift',
                            revenueTarget: '$2,000.00',
                            revenueActual: '$2,200.00',
                            revenueVariance: '$200.00',
                            labourTarget: '$700.00',
                            labourActual: '$600.00',
                            labourActualPercent: '27.27%',
                            labourVariance: '-$100.00'
                        },
                        {
                            shift: 'Dinner',
                            revenueTarget: '$800.00',
                            revenueActual: '$950.00',
                            revenueVariance: '$150.00',
                            labourTarget: '$300.00',
                            labourActual: '$220.00',
                            labourActualPercent: '23.16%',
                            labourVariance: '-$80.00'
                        },
                        {
                            shift: 'Supper',
                            revenueTarget: '$1,200.00',
                            revenueActual: '$1,250.00',
                            revenueVariance: '$50.00',
                            labourTarget: '$400.00',
                            labourActual: '$380.00',
                            labourActualPercent: '30.40%',
                            labourVariance: '-$20.00'
                        },
                        {
                            shift: 'Day Total',
                            revenueTarget: '$4,000.00',
                            revenueActual: '$4,400.00',
                            revenueVariance: '$400.00',
                            labourTarget: '$1,400.00',
                            labourActual: '$1,200.00',
                            labourActualPercent: '27.27%',
                            labourVariance: '-$200.00'
                        }
                    ]
                }
            ]
        }
    },
    methods: {
        handleTypeChange(value) {
            this.typeSelected = value;
        },
        tableRowClassName({row, rowIndex}) {
            if (row.shift === 'Day Total') {
                return 'total-row';
            }
            return '';
        }
    }
}
</script>

<style lang="scss" scoped>
.eos-report__revenue-labour-history {
    .eos-report__revenue-labour-history--date {
        margin-bottom: 20px;
        display: flex;
        gap: 10px;
        align-items: center;
    }
    
    .custom-table {
        /deep/ .el-table {
            .total-row {
                background-color: var(--background-color-3);
                color: white;
                font-weight: bold;
                
                td {
                    background-color: var(--background-color-3) !important;
                    color: white !important;
                }
            }
            
            .el-table__header-wrapper {
                .el-table__header {
                    th {
                        background-color: var(--background-color-3) !important;
                        color: #606266;
                        font-weight: bold;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/eos/eosRevenueLabourHistory.vue